import React from 'react';
import { Link } from 'react-router-dom';
import IconHeart from '../../../../../../svg/IconHeart';
import IconBadFish from '../../../../../../svg/IconBadFish';
import Css from './TitleItemMoby.module.css';

function TitleItemMoby({title,idItem,ppid,code,price,getCatalogItemsFish,basketFish}) {
  const [valueFish, setvalueFish] = React.useState(basketFish);
  const Fish = () => {

    if(valueFish){

      setvalueFish(false);
      getCatalogItemsFish(idItem, ppid, price, title, code,valueFish);

    }
    else{

      setvalueFish(true);
      getCatalogItemsFish(idItem, ppid, price, title, code,valueFish);

    }
   
  };

  return (
    <div className={Css.content}>
      <div><a  className={Css.linkTitle} href={`/${code}/`} onClick={()=>window.scrollTo({top: 0, behavior: 'smooth'})} >{title}</a></div> 
      <div className={Css.fish} onClick={Fish} >
        {valueFish? <IconBadFish/> : <IconHeart/> }
      </div>
    </div>
  );
}

export default TitleItemMoby;